"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = getConfig;
exports.setConfig = setConfig;
exports.useConfig = void 0;
var _react = require("react");
var _ahooks = require("ahooks");
var _locale = _interopRequireDefault(require("../locale"));
var _day = require("../_util/day");
const defaultConfig = {
  locale: _locale.default,
  dayjs: {
    localeName: 'en'
  }
};
const _event = 'ZENDESIGNCONFIG';
const _eventKey = 'config';
function customUserEvent(value) {
  var event = new Event(_event);
  event.key = _eventKey;
  event.newValue = value;
  window.dispatchEvent(event);
}
function getConfig() {
  return typeof window !== "undefined" ? window._ZEND_config || defaultConfig : defaultConfig;
}
if (getConfig()) {
  (0, _day.setDayjsLocale)(getConfig().dayjs.localeName);
}
function setConfig(config) {
  const newConfig = {
    ...getConfig(),
    ...config
  };
  (0, _day.setDayjsLocale)(newConfig.dayjs.localeName);
  window._ZEND_config = newConfig;
  customUserEvent(newConfig);
  return newConfig;
}
const addConfigEventListener = eventFn => {
  function _eventFn(e) {
    window.setTimeout(() => {
      eventFn(getConfig(), e);
    });
  }

  //当前tab页有效
  window.addEventListener(_event, _eventFn);
  return () => {
    window.removeEventListener(_event, _eventFn);
  };
};
const useConfig = () => {
  const [config, setConfig] = (0, _react.useState)(getConfig());
  const latestConfigRef = (0, _ahooks.useLatest)(config);
  (0, _react.useEffect)(() => {
    const removeEventListener = addConfigEventListener((newConfig, e) => {
      if (newConfig !== latestConfigRef.current) {
        setConfig(newConfig);
      }
    });
    return () => {
      removeEventListener();
    };
  }, []);
  return config;
};
exports.useConfig = useConfig;